
import PhotoSwipe from 'photoswipe'
import photoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default.js'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

export default {
  data () {
    return {
      gallery: null
    }
  },
  methods: {
    handleImageClick() {
      console.log(this.$el)
      let nodes = Array.prototype.slice.call(this.$el.querySelectorAll('.iframe img'))
      nodes = nodes.filter((node) => {
        return node.src
      })
      if (!nodes.length) return
      nodes.forEach((node, index) => {
        node.addEventListener('click', () => {
          if (this.gallery) return
          const imgData = nodes.map(img => {
            if (img.naturalWidth && img.naturalHeight) {
              return {
                src: img.src,
                w: img.naturalWidth,
                h: img.naturalHeight
              }
            } else {
              return {}
            }
          })
          if (!imgData.length) return
          const pswpElement = document.querySelectorAll('.pswp')[0]
          const options = {
            // history & focus options are disabled on CodePen
            history: false,
            focus: false,
            index,       // 设置初始显示图片index
            showAnimationDuration: 0,
            hideAnimationDuration: 0
          }
          this.gallery = new PhotoSwipe(pswpElement, photoSwipeUIDefault, imgData, options)
          this.gallery.init()
          this.gallery.listen('close', () => {
            setTimeout(() => {
              this.gallery = null
            }, 100)
          })
        })
      })
    }
  }
}
